// extracted by mini-css-extract-plugin
module.exports = {"container":"VariantsListEmptyState_container__xkr5f","link":"VariantsListEmptyState_link__Bul8P"};